var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14937 1.78739C4.85906 1.38942 5.72859 1.40583 6.42328 1.83005L19.9219 10.0782C20.5922 10.4907 21 11.2172 21 12C21 12.7829 20.5922 13.5094 19.9219 13.8797L6.42328 22.1297C5.72859 22.5938 4.85906 22.6125 4.14937 22.2141C3.43955 21.8157 3 21.0657 3 20.25V3.75005C3 2.9363 3.43955 2.18583 4.14937 1.78739Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.462207a8d345779bf3ccd42bc49f27e8.svg";
export { ForwardRef as ReactComponent };